import React from 'react';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import { isBranchEnv } from 'brand-config';
import { Label } from 'core/components/label';
import useMotionPreference from 'core/hooks/use-motion-preference';
import { illustrationForPolicyType } from './policy-type-illustration';
import Home from './assets/checkhome.svg?react';
import Auto from './assets/checkauto.svg?react';
import Farm from './assets/teamwork.svg?react';
import Condo from './assets/neighbor.svg?react';
import Renters from './assets/watering.svg?react';
import useStyles from './illustrated-loader.styles';

const illustrations = { home: Home, auto: Auto, farm: Farm, condo: Condo, renters: Renters };

export default function IllustratedLoader({ waiting = true, policyType, label, className, quiet = false }) {
  const classes = useStyles();
  const { loadingEnabled } = useMotionPreference();
  const kind = illustrationForPolicyType(policyType);
  const Artwork = illustrations[kind];
  const decorated = loadingEnabled && isBranchEnv && Artwork;
  if (!waiting || (quiet && !decorated)) {
    return null;
  }
  const content = (
    <div
      className={classNames(classes.root, className)}
      role="status"
      tabIndex={decorated ? -1 : undefined}
      aria-live="polite"
      data-wait={decorated ? 'illustrated' : 'quiet'}
    >
      {decorated && <Artwork className={classes.art} aria-hidden="true" data-testid="wait-art" data-policy={kind} />}
      {!decorated && <CircularProgress className={classes.spinner} size={24} aria-label={label} />}
      <Label className={classes.label} type="darkGreenMedium">
        {label}
      </Label>
    </div>
  );
  return decorated ? (
    <Modal open hideBackdrop>
      {content}
    </Modal>
  ) : (
    content
  );
}

IllustratedLoader.propTypes = {
  waiting: PropTypes.bool,
  policyType: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  quiet: PropTypes.bool
};
